import * as React from 'react';
import MapWithInfo from '~/components/MapWithInfo';
import Map from '~/components/Map';
import { MapEvent } from '~/config/map';
import { tHtml } from '~/i18n';

interface GeofenceMapProps {
  siteId: number | string;
  onPlaneChange: (value: string) => void;
  onZonesChange: (zones: string[]) => void;

  selectedPlane?: string;
  isSelectable: boolean;
  selectedZones: string[];
}

const GeofenceMap: React.FC<GeofenceMapProps> = ({
  siteId,
  selectedPlane,
  onPlaneChange,
  selectedZones,
  onZonesChange,
  isSelectable,
}) => {
  const geofenceMap = React.useRef<Map>(null);
  React.useEffect(() => {
    if (!geofenceMap.current) {
      return;
    }
    geofenceMap.current.listenToEvent(MapEvent.PlaneUpdated, onPlaneChange);
    return () => {
      if (geofenceMap.current) {
        geofenceMap.current.removeEventListener(onPlaneChange);
      }
    };
  }, [onPlaneChange]);
  React.useEffect(() => {
    const onGeofenceUpdate = ({ zones }) => {
      onZonesChange(zones);
    };
    geofenceMap.current?.listenToEvent(
      MapEvent.GeoFenceUpdate,
      onGeofenceUpdate
    );
    return () => {
      if (geofenceMap.current) {
        geofenceMap.current.removeEventListener(onGeofenceUpdate);
      }
    };
  }, [onZonesChange]);
  React.useEffect(() => {
    geofenceMap.current?.sendEvent(MapEvent.PlaneUpdated, selectedPlane);
  }, [selectedPlane]);
  React.useEffect(() => {
    geofenceMap.current?.sendEvent(MapEvent.GeoFenceUpdate, {
      zones: selectedZones,
    });
  }, [selectedZones]);

  React.useEffect(() => {
    geofenceMap.current?.sendEvent(
      MapEvent.GeoFenceSelectableUpdate,
      isSelectable
    );
  }, [isSelectable]);
  return (
    <MapWithInfo info={tHtml('geofence.preview')}>
      <Map page="geofence-editor" siteId={siteId} ref={geofenceMap} height={500} />
    </MapWithInfo>
  );
};

export default GeofenceMap;
